import { createAction, props } from '@ngrx/store';

export const generalConsultLabels = {
  SET_PATIENT: 'GENERAL_CONSULT_SET_PATIENT',
  SET_SAVING: 'GENERAL_CONSULT_SET_SAVING',
  ADD_TO_SAVED: 'GENERAL_CONSULT_ADD_TO_SAVED',
  SET_SAVE: 'GENERAL_CONSULT_SET_SAVE',
  SET_ALL_DEFAULT: 'GENERAL_CONSULT_SET_ALL_DEFAULT',
};

export const generalConsultActions = {
  setPatientAction: createAction(
    generalConsultLabels.SET_PATIENT,
    props<{ patient: number }>()
  ),
  setSavingAction: createAction(
    generalConsultLabels.SET_SAVING,
    props<{ saving: boolean }>()
  ),
  addToSavedAction: createAction(
    generalConsultLabels.ADD_TO_SAVED,
    props<{ value: number }>()
  ),
  setSaveAction: createAction(
    generalConsultLabels.SET_SAVE,
    props<{ save: boolean }>()
  ),
  setAllDefaultAction: createAction(
    generalConsultLabels.SET_ALL_DEFAULT,
    props<any>()
  ),
};
